import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import EmergentWingman from './EmergentWingman';
import { company } from '../../mock';
import useAppointmentReminders from '../../hooks/useAppointmentReminders';

export default function AppShell({ children }) {
  // Desktop-only collapse state (the chevron toggle inside the sidebar).
  const [sidebarExpanded, setSidebarExpanded] = useState(true);
  // Mobile drawer visibility. Default closed; hamburger in TopBar opens it.
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  useAppointmentReminders();

  // Auto-close the mobile drawer on route change so tapping a nav item
  // collapses the menu the same way native apps do.
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // Lock body scroll while the mobile drawer is open.
  useEffect(() => {
    if (mobileOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = prev; };
    }
  }, [mobileOpen]);

  const handleMenuClick = () => {
    // On small screens the hamburger always opens the drawer.
    // On large screens it collapses/expands the desktop sidebar.
    if (window.matchMedia('(min-width: 1024px)').matches) {
      setSidebarExpanded((v) => !v);
    } else {
      setMobileOpen((v) => !v);
    }
  };

  return (
    <div className="min-h-screen flex bg-[hsl(var(--kf-canvas))]">
      <Sidebar
        expanded={sidebarExpanded}
        onToggleExpanded={() => setSidebarExpanded(!sidebarExpanded)}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar onMenuClick={handleMenuClick} />
        <main className="flex-1 min-w-0 px-4 sm:px-6 lg:px-10 py-6 sm:py-8 animate-fadeUp">
          {children}
        </main>
        <footer className="relative px-4 sm:px-6 lg:px-10 py-5 text-[11px] text-neutral-500 flex flex-wrap items-center justify-between gap-2 border-t hairline bg-white dark:bg-neutral-950 dark:text-neutral-400">
          <div className="flex items-center gap-2">
            <span className="brand-word text-neutral-800 dark:text-neutral-200 text-[11px]">Kinfolk</span>
            <span className="text-neutral-300 dark:text-neutral-700">|</span>
            <span>Broker CRM</span>
            <span className="mono hidden sm:inline">· v4.2.0 · Last sync 2m ago</span>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden sm:inline">Equal Housing Lender</span>
            <span className="hidden sm:inline text-neutral-300 dark:text-neutral-700">·</span>
            <span>{company.nmls}</span>
            <span className="hidden sm:inline text-neutral-300 dark:text-neutral-700">·</span>
            <span>© 2026 {company.name}</span>
          </div>
        </footer>
      </div>
      <EmergentWingman />
    </div>
  );
}
